import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from '@kanzi-apes/kanzi-prime-ui';
import { fromEvent, Subject } from 'rxjs';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import { KanziAnalyticsReportsService } from '../../services/kanzi-analytics-reports.service';
import {
  flightReportTableColumns,
  flightReport,
} from '../../configs/table.configs';
import {
  ConfigTableModel,
  FilterOptions,
  FlightReportListModel,
} from '@kanzi-apes/kanzi-models';
import { tap, map, switchMap, takeUntil } from 'rxjs/operators';
import moment from 'moment';
import { Observable } from 'rxjs';
import { timer } from 'rxjs';
import { BreadcrumbService } from '@kanzi-apes/kanzi-ui';
import { ConfigSimpleTable } from '@kanzi-apes/kanzi-ui-configs';

@Component({
    selector: 'kanzi-apes-analytics-report-flight-status',
    templateUrl: './kanzi-analytics-report-flight-status.component.html',
    styleUrls: ['./kanzi-analytics-report-flight-status.component.scss'],
    standalone: false
})
export class KanziAnalyticsReportFlightStatusComponent
  implements OnInit, OnDestroy
{
  private unsubscribe$ = new Subject<void>();

  headerConfig: any;
  breadcrumbMenu: MenuItem[] = [];
  cols: any[] = flightReportTableColumns;
  configsTable!: ConfigTableModel;
  appModules = this.envService.environment?.modules;
  reportList!: FlightReportListModel;
  filterOptions!: FilterOptions;
  optionsFilter: string[] = flightReport;

  reportFlight$: Observable<FlightReportListModel> = this.analyticsReportService
    .getFlightReport()
    .pipe(
      map((data) => this.transformData(data)),
      tap((response) => this.generateFilters(response))
    );

  constructor(
    private envService: EnvironmentService,
    private analyticsReportService: KanziAnalyticsReportsService,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {    
    this.configsTable = new ConfigSimpleTable('Report-Flights');
    this.filterOptions = new FilterOptions(this.cols);

    fromEvent(window, 'online').subscribe((_) => {
      console.log('online');
      this.getDataReport();
    });

    fromEvent(window, 'offline').subscribe((_) => {
      console.log('Offline');
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    });

    this.getDataReport();
  }

  getDataReport() {
    timer(0, 60000)
      .pipe(
        takeUntil(this.unsubscribe$),
        switchMap((_) => this.reportFlight$)
      )
      .subscribe((data) => {
        this.reportList = data;
      });
  }

  generateFilters(data: any) {
    if (data) {
      this.filterOptions.createFilterOptions(data.results, this.optionsFilter);

      this.cols = this.filterOptions.cols.map((col) => ({
        ...col,
        sortable: true,
      }));
    }
  }

  transformData(data: FlightReportListModel): FlightReportListModel {
    return {
      ...data,
      results:
        data.results.length > 0
          ? data.results.map((item) => ({
              ...item,
              created: item.created ? moment(item['created']).format('ll') : '',
          /*     withdrawal_request_datetime: item.withdrawal_request_datetime
                ? moment(new Date(item['withdrawal_request_datetime'])).format(
                    'DD-MM-YYYY, h:mm a'
                  )
                : '', */
              delta_withdrawal_request: item.delta_withdrawal_request
                ? item['delta_withdrawal_request'].split(',')[0].split('.')[0]
                : '',
            }))
          : [],
    };
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
